import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private authService: AuthService, 
    private router: Router) { }

  canActivate() {
    if (!this.authService.isLoggedIn()) {
      let state = localStorage.getItem('state');
      this.router.navigate(["/error-page"], { queryParams: { state: state, errorCode: '00' } }).then(() => {
        localStorage.clear();
        window.location.reload();
      });
    }
    return this.authService.isLoggedIn();
  }
}